import { Button, Meta, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useActiveElementStore } from 'stores/activeElementStore';
import { useMapStore } from 'stores/mapStore';
import { StyledWrapper } from 'styles/ContainerStyles';
import { useUiStore } from 'stores/uiStore';

const ConfirmParkingClosedZoneModalContent: React.FC = () => {
  const { t } = useTranslation();
  const uid = useActiveElementStore((state) => state.activeElement);

  const confirmStartParking = () => {
    useMapStore.getState().setCanStartParkingZoneUid(uid);
    useUiStore.getState().setSheetModal('');
  };
  const onBackPress = () => {
    useUiStore.getState().setSheetModal('');
  };

  return (
    <StyledWrapper mb={0}>
      <StyledWrapper maxWidth={335} center mb={40}>
        <Meta
          center
          color={theme.colors.gray300}
          testID="confirm-closed-parking-description">
          {t('parking.closedZoneConfirmDescription')}
        </Meta>
      </StyledWrapper>
      <StyledWrapper mb={0}>
        <StyledWrapper>
          <Button
            testID="confirm-closed-parking-confirm-button"
            size="l"
            text={t('button.confirm')}
            onPress={confirmStartParking}
          />
        </StyledWrapper>
        <StyledWrapper mb={0}>
          <Button
            testID="confirm-closed-parking-cancel-button"
            size="l"
            buttonType="tertiary"
            text={t('button.cancel')}
            onPress={onBackPress}
          />
        </StyledWrapper>
      </StyledWrapper>
    </StyledWrapper>
  );
};

export default ConfirmParkingClosedZoneModalContent;
